(ns web3.screens.transfer
  (:require [web3.view :as v]
            [reagent.core :as r]
            [web3.queries.property :as q-property]
            [web3.routing.core :as routing]
            [web3.persistence.schema :as schema]
            [web3.components.widgets :as w]
            [web3.modals.alerts :as alerts]
            [web3.i18n :as i]
            [web3.screens.property :as property]
            [clojure.set :as set]
            [web3.components.progress :as progress]
            [web3.persistence.local :as local]
            [web3.persistence.graphql :as g]
            [web3.env :as env]
            [re-frame.core :as rf]
            [web3.queries.root :as q-root]
            [web3.auth.api :as auth]))

(v/defview accept-redirect
  "Redirect to the root transfer-acceptance modal screen."
  {:allow-public true
   :component-did-mount
   (fn [this]
     (auth/start-flow :renew-softly)
     (routing/nav! (routing/path-for
                     :router/root [:blank/public]
                     :router/form-modal [:property-transfer/accept.start :transfer-id (-> this
                                                                                          :props
                                                                                          :transfer-id)])))}
  [_]
  [:div])

(defn signup-or-login!
  [{:keys [transfer-id]}]
  (let [acceptance-path (fn [signup?]
                          ;; the route below requires auth, so it will trigger a sign-in/sign-up flow.
                          (routing/path-for
                            :router/root [:blank/authed]
                            :router/form-modal [:property-transfer/accept.continue :transfer-id transfer-id]
                            ;; our auth code looks for a `:signup=true` query param when deciding what
                            ;; screen to show the user on the hosted login page.
                            :query (when signup? {:signup true})))]
    (alerts/add-frame
     [alerts/alert-view
      {:text-primary (i/to-do (str "Do you have a " (:partner/name env/config) " account?"))
       :text-secondary (i/to-do "Sign up for a free account or log in to continue.")
       :buttons [{:label "Login"
                  :href (acceptance-path false)}
                 {:label "Signup"
                  :href (acceptance-path true)}]}])))

(defn nicknames [{:keys [originator]
                  :as transfer-info}]
  (merge transfer-info
         {:originator-nickname (schema/user-nickname originator)
          :recipient-nickname (or
                                (when (auth/local-authed?)
                                  (-> (q-root/me)
                                      :me
                                      (schema/user-nickname)))
                                (-> transfer-info
                                    (set/rename-keys {:recipientEmail :email
                                                      :recipientFirstName :firstName
                                                      :recipientLastName :lastName})
                                    (schema/user-nickname)))}))

(defn transfer-accepted-alert! []
  (alerts/add-frame
   [alerts/alert-view
    {:text-primary (i/to-do "Welcome to your new home!")
     :text-secondary (i/to-do "The property transfer has been completed. It’s all yours now.")
     :buttons [{:label (i/to-do "Thank You")
                :on-click #(alerts/drop-frames 1)}]}]))

(defn transfer-accept! [{:keys [transfer-id
                                component]} e]
  (some-> e (.preventDefault))
  (q-property/property-transfer-request-accept {:id transfer-id}
                                               {:component component
                                                :on-complete
                                                (fn [result]
                                                  (-> #(let [property-id (-> result
                                                                             (js->clj :keywordize-keys true)
                                                                             :data
                                                                             :propertyTransferRequest_accept
                                                                             :property
                                                                             :id)]
                                                         (routing/nav!
                                                           (routing/path-for :router/root [:home/property :property-id property-id]
                                                                             :router/form-modal nil))
                                                         (transfer-accepted-alert!))

                                                      ;; we use a timeout because we need to let
                                                      ;; apollo update the local cache before
                                                      ;; navigating to the property.
                                                      (js/setTimeout 100)))}))

(v/defview accept-continue
  {:header false
   :component-did-mount (fn [{:as this
                              {:keys [transfer-id]} :props}]
                          (when (auth/local-authed?)
                            (transfer-accept! {:transfer-id transfer-id
                                               :component this} nil)))}
  [_]
  (let [{:as mutation-state
         :keys [graphql/loading?]} (g/mutation-state (r/current-component))]
    [:div.flex.flex-column.items-center.justify-center
     [w/graphql-state mutation-state]
     [:div.pad-all-3.text-center.text-dark-gray
      (cond (not (auth/local-authed?)) (i/to-do "Authenticating...")
            loading? (i/to-do "Transferring Property..."))]]))

(v/defview accept-start
  {:header false
   :modal/on-close (constantly false)}
  [{:keys [transfer-id] :as tp}]
  (let [{:keys [graphql/loading?
                propertyTransferRequest_info]} (q-property/property-transfer-request-info
                                                 {:id transfer-id}
                                                 {:on-complete js/console.log})
        {:as query-result
         :keys [originator-nickname
                recipient-nickname]} (some-> propertyTransferRequest_info
                                             (nicknames))
        product-count 15
        group-count 12
        file-count 3
        p :div.margin-v-3.text-dark-gray.line-h-18
        this (r/current-component)]
    (cond
      loading? [progress/indeterminate]
      (nil? propertyTransferRequest_info) [:div.pad-all-3.flex.flex-column.height-100p
                                           [:div.flex.flex-auto.items-center.justify-center "Sorry, this transfer is no longer valid."]
                                           [w/black-button {:href "/"} "Home"]]
      :else [:div.pad-all-3
             [:div.header-2 (str "Hi " recipient-nickname \,)]
             [p [:span.text-black originator-nickname] (str " has invited you to use " (:partner/name env/config) " for your property:")]
             [w/form-card (-> query-result
                              (set/rename-keys {:propertyNickname :nickname
                                                :propertyAddress :address})
                              (property/formatted-property))]
             [p (str (:partner/name env/config) "helps you manage your home and the things in it. "
                     "For any product you add to HomeServe, it provides manuals, "
                     "how-to videos, parts, accessories, and monitors for recalls.")]
             [p (str originator-nickname " has preloaded the property for you with "
                     product-count " products in " group-count " groups and " file-count
                     " images, notes and other files")]
             [:div.pad-all-3
              (if (auth/local-authed?)
                [:form
                 {:on-submit (partial transfer-accept! {:component this
                                                        :transfer-id transfer-id})}
                 [w/graphql-submit-button
                  {:state (g/mutation-state this)
                   :label (i/get :i/accept-transfer)}]]
                [w/black-button
                 {:on-click (partial signup-or-login! {:transfer-id transfer-id})}
                 (i/get :i/accept-transfer)])]
             [p (str "Once you accept the invitation the property will be yours exclusively"
                     " and " originator-nickname " will no longer have access.")]
             [p "If you have questions or concerns, please contact support@homeserveapp.com."]])))

